// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 12C19 7.58171 15.8661 4 12 4C8.13394 4 5 7.58171 5 12C5 16.4183 8.13394 20 12 20C15.8661 20 19 16.4183 19 12ZM10.2681 16.8601L15.2554 8.62988C15.8459 9.54853 16.2 10.7217 16.2 12C16.2 14.9455 14.3197 17.3333 12 17.3333C11.3826 17.3333 10.7961 17.164 10.2681 16.8601ZM7.8 12C7.8 9.05452 9.68034 6.66667 12 6.66667C12.6174 6.66667 13.2039 6.83593 13.7319 7.13981L8.74455 15.3701C8.1541 14.4515 7.8 13.2783 7.8 12Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
